export default __webpack_public_path__ + "static/media/Colonial Penn Dark.6a8840c2.svg";